import React from 'react'

import IncidentDate from '../../incidents/components/IncidentDate'

const HCFRIncidentListItem = ({ incident }) => {
  const {
    incidentNumber,
    incidentDate,
    location,
    areaName,
    incidentTypeCode,
    incidentTypeDescription,
  } = incident

  return (
    <tr>
      <td>{incidentNumber}</td>
      <td>
        <IncidentDate date={incidentDate} />
      </td>
      <td>{location}</td>
      <td>{areaName}</td>
      <td>{incidentTypeCode}</td>
      <td>{incidentTypeDescription}</td>
    </tr>
  )
}

export default HCFRIncidentListItem
